export const NODE_COLORS: Record<string, string> = {
  ApexClass:                "#4f8cff",
  ApexTrigger:              "#ec4899",
  CustomObject:             "#22c55e",
  StandardObject:           "#14b8d4",
  CustomField:              "#a78bfa",
  Field:                    "#a78bfa",
  Flow:                     "#f59e0b",
  ValidationRule:           "#ef4444",
  PermissionSet:            "#eab308",
  Profile:                  "#f97316",
  Layout:                   "#38bdf8",
  LightningComponentBundle: "#8b5cf6",
  AuraDefinitionBundle:     "#7c3aed",
};

export const DEFAULT_NODE_COLOR = "#94a3b8";

export function nodeColor(type: string): string {
  return NODE_COLORS[type] ?? DEFAULT_NODE_COLOR;
}

export const LINK_COLORS: Record<string, string> = {
  CALLS:         "#4f8cff",
  EXTENDS:       "#a78bfa",
  IMPLEMENTS:    "#a78bfa",
  HAS_FIELD:     "#22c55e",
  DEFINES_SCHEMA:"#22c55e",
  HAS_PICKLIST:  "#22c55e",
  RELATES_TO:    "#f59e0b",
  DEPENDS_ON:    "#f59e0b",
};

export const DEFAULT_LINK_COLOR = "#64748b";

export function linkColor(rel: string): string {
  return LINK_COLORS[rel] ?? DEFAULT_LINK_COLOR;
}

export const EDGE_TYPE_GROUPS: Array<{
  key: string;
  label: string;
  color: string;
  rels: string[];
}> = [
  { key: "CALLS",              label: "CALLS",               color: "#4f8cff", rels: ["CALLS"] },
  { key: "EXTENDS_IMPLEMENTS", label: "EXTENDS / IMPLEMENTS", color: "#a78bfa", rels: ["EXTENDS", "IMPLEMENTS"] },
  { key: "HAS_FIELD_DEFINES",  label: "HAS_FIELD / DEFINES",  color: "#22c55e", rels: ["HAS_FIELD", "DEFINES_SCHEMA", "HAS_PICKLIST"] },
  { key: "RELATES_TO",         label: "RELATES_TO",           color: "#f59e0b", rels: ["RELATES_TO", "DEPENDS_ON"] },
  { key: "OTHER",              label: "Other",                color: "#64748b", rels: [] },
];

export function nodeRadius(degree?: number): number {
  return 6 + Math.min(11, (degree ?? 0) * 0.26);
}

// Top N nodes by degree that always show a label
export const HUB_LABEL_COUNT = 14;
